
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { useState } from 'react';
import { MultiSelect, Size } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';
import { ControlledMultiField } from '../utils';
export const Controller = ({
  children
}) => {
  const [options, setOptions] = useState([{
    label: 'Apple',
    value: 'Apple'
  }, {
    label: 'Pear',
    value: 'Pear'
  }, {
    label: 'Strawberry',
    value: 'Strawberry'
  }]);
  const [selected, setSelected] = useState([]);
  return children({
    options,
    setOptions,
    selected,
    setSelected
  });
};

const layoutProps = {
  Controller
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Multi Select`}</h1>
<p>{`Usage`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { MultiSelect } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<ControlledMultiField style={{ maxWidth: 280, height: 300 }} component={
  <MultiSelect
    placeholder="Select options..."
    options={[{
      label: 'Belgium',
      value: 'BE',
    }, {
      label: 'France',
      value: 'FR',
    }, {
      label: 'Italy',
      value: 'IT',
    }, {
      label: 'Greece',
      value: 'GR',
    }]} />
} />`} component={MultiSelect} mdxType="Playground">
  <ControlledMultiField style={{
        maxWidth: 280,
        height: 300
      }} component={<MultiSelect placeholder="Select options..." options={[{
        label: 'Belgium',
        value: 'BE'
      }, {
        label: 'France',
        value: 'FR'
      }, {
        label: 'Italy',
        value: 'IT'
      }, {
        label: 'Greece',
        value: 'GR'
      }]} mdxType="MultiSelect" />} mdxType="ControlledMultiField" />
</Playground>

<h3>{`Multi Select with editable options`}</h3>
<Playground __position={1} __code={`<div style={{ maxWidth: 280, height: 300 }}>
  <Controller>
    {({ options, setOptions, selected, setSelected }) => (
      <MultiSelect
        allowTyping
        placeholder="Select fruits..."
        typeZonePlaceholder="Add more fruit..."
        options={options}
        values={selected}
        onChange={setSelected}
        onChangeOptions={setOptions} />
      )}
  </Controller>
</div>`} mode="jsx" mdxType="Playground">
  <div style={{
        maxWidth: 280,
        height: 300
      }}>
    <Controller mdxType="Controller">
      {({
            options,
            setOptions,
            selected,
            setSelected
          }) => <MultiSelect allowTyping placeholder="Select fruits..." typeZonePlaceholder="Add more fruit..." options={options} values={selected} onChange={setSelected} onChangeOptions={setOptions} mdxType="MultiSelect" />}
    </Controller>
  </div>
</Playground>
<h3>{`Multi Select without options dropdown`}</h3>
<p>{`This can be useful if you want the user to pick all the options (i.e. without defaults). This pattern is used when choosing email addresses for a mailing list for example.`}</p>
<Playground __position={2} __code={`<div style={{ maxWidth: 500, height: 300 }}>
  <Controller>
    {({ options, setOptions, selected, setSelected }) => (
      <MultiSelect
        allowTyping
        hideOptions
        placeholder="Type to add emails..."
        typeZonePlaceholder="Add more emails..."
        options={options}
        values={selected}
        onChange={setSelected}
        onChangeOptions={setOptions} />
      )}
  </Controller>
</div>`} mode="jsx" mdxType="Playground">
  <div style={{
        maxWidth: 500,
        height: 300
      }}>
    <Controller mdxType="Controller">
      {({
            options,
            setOptions,
            selected,
            setSelected
          }) => <MultiSelect allowTyping hideOptions placeholder="Type to add emails..." typeZonePlaceholder="Add more emails..." options={options} values={selected} onChange={setSelected} onChangeOptions={setOptions} mdxType="MultiSelect" />}
    </Controller>
  </div>
</Playground>
<h3>{`Multi Select as an input for multiple text`}</h3>
<Playground __position={3} __code={`<div style={{ maxWidth: 500, height: 300 }}>
  <ControlledMultiField style={{ maxWidth: 280, height: 300 }} component={
      <MultiSelect
        placeholder="Type to add emails..."
      />
    }
  />
</div>`} mode="jsx" mdxType="Playground">
  <div style={{
        maxWidth: 500,
        height: 300
      }}>
    <ControlledMultiField style={{
          maxWidth: 280,
          height: 300
        }} component={<MultiSelect placeholder="Type to add emails..." mdxType="MultiSelect" />} mdxType="ControlledMultiField" />
  </div>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;